export enum InvalidPeriodType {
	LunchBreak = 'PAUSE_REPAS',
	FarmClosed = 'FERMETURE_FERME',
	NotWorking = 'HORS_HORAIRES_TRAVAIL'
}

export enum SchedulerViewMode {
	TASK_INTERVAL = 'TASK_INTERVAL',
	FARM_TIME = 'FARM_TIME'
}